module.exports = __webpack_public_path__ + "static/media/ios_logo.f9a6fadb.png";